import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { FormattedRelyingPartyConfig, RelyingPartyConfig } from "@idw-types/data/relying-party-config";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";
import { handleRequestWithBody } from "@utils/http-util";
import { injectRelyingPartyId } from "@utils/parameter-injector";

type UpdateRelyingPartyRequestResponse = {
    transferObject: RelyingPartyConfig;
};

export const updateRelyingPartyRequest = async (
    relyingParty: FormattedRelyingPartyConfig
): Promise<GenericNetworkResponse<UpdateRelyingPartyRequestResponse>> => {
    const route = injectRelyingPartyId(
        apiRoutes.axnadminCore.axn.relyingpartyWithId,
        relyingParty.id
    );

    const body = {
        id: relyingParty.id,
        companyID: relyingParty.company.id,
        name: relyingParty.name,
        contractCode: relyingParty.contractCode ? relyingParty.contractCode : null,
        contractCodeEdit: relyingParty.contractCode ? relyingParty.contractCode : null,
        customAXNHostName: relyingParty.customAXNHostName ? relyingParty.customAXNHostName : null,
        customAXNHostNameEdit: relyingParty.customAXNHostName ? relyingParty.customAXNHostName : null,
        customDCUIHostName: relyingParty.customDCUIHostName ? relyingParty.customDCUIHostName : null,
        customDCUIHostNameEdit: relyingParty.customDCUIHostName ? relyingParty.customDCUIHostName : null,
        whiteLabelAXNUI3HostName: relyingParty.whiteLabelAXNUI3HostName ? relyingParty.whiteLabelAXNUI3HostName : null,
        whiteLabelAXNUI3HostNameEdit: relyingParty.whiteLabelAXNUI3HostName ? relyingParty.whiteLabelAXNUI3HostName : null,
        whiteLabelAXNUIHostName: relyingParty.whiteLabelAXNUIHostName ? relyingParty.whiteLabelAXNUIHostName : null,
        whiteLabelAXNUIHostNameEdit: relyingParty.whiteLabelAXNUIHostName ? relyingParty.whiteLabelAXNUIHostName : null,
        whiteLabelDCUIHostName: relyingParty.whiteLabelDCUIHostName ? relyingParty.whiteLabelDCUIHostName : null,
        whiteLabelDCUIHostNameEdit: relyingParty.whiteLabelDCUIHostName ? relyingParty.whiteLabelDCUIHostName : null,
        whiteLabelKBAHostName: relyingParty.whiteLabelKBAHostName ? relyingParty.whiteLabelKBAHostName : null,
        whiteLabelKBAHostNameEdit: relyingParty.whiteLabelKBAHostName ? relyingParty.whiteLabelKBAHostName : null,
        whiteLabelKBA2HostName: relyingParty.whiteLabelKBA2HostName ? relyingParty.whiteLabelKBA2HostName : null,
        whiteLabelKBA2HostNameEdit: relyingParty.whiteLabelKBA2HostName ? relyingParty.whiteLabelKBA2HostName : null,
        status: relyingParty.status
    };

    const { data, error } = await handleRequestWithBody(RequestTypes.PUT, route, body);
    return { data, error, body };
};